import { Grid } from "@mui/material";
import FormSkeleton from "components/FormSkeleton/FormSkeleton";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import ProductGroupUpdate from "modules/productGroups/ProductGroupUpdate";
import { useParams } from "react-router";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";
import useGetProductGroup from "hooks/products/useGetProductGroup";
import { ProductGroup } from "generated/graphql";

export default function ProductGroupUpdatePage() {
  const { productGroupId } = useParams();

  const { data: productGroup, loading, error } = useGetProductGroup({ id: productGroupId });

  return (
    <DashboardPage>
      {loading && <FormSkeleton rows={4} />}
      {error && <MDAlert color="error">{parseGraphQLError(error)}</MDAlert>}
      {!loading && !error && productGroup && (
        <>
          <MDBox mb={6}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} lg={6}>
                <MDTypography variant="h4" fontWeight="medium">
                  Update Product Group
                </MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ProductGroupUpdate productGroup={productGroup as ProductGroup} />
            </Grid>
          </Grid>
        </>
      )}
    </DashboardPage>
  );
}
